import { encodeString } from "./index";

export const checkStorageAvailability = type => {
  let storage;

  try {
    storage = window[type];
    const CHECK_STORAGE = "_check_storage_availability_";

    storage.setItem(CHECK_STORAGE, CHECK_STORAGE);
    storage.removeItem(CHECK_STORAGE);

    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      (e.code === 22 ||
        e.code === 1014 ||
        e.name === "QuotaExceededError" ||
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      storage &&
      storage.length !== 0
    );
  }
};

export const removeLocalStorage = (id, key) => {
  localStorage.removeItem(`${encodeString(`botId-${id}-${key}`)}`);
  localStorage.removeItem(`${encodeString(`userId-${id}-${key}`)}`);
  localStorage.removeItem(`${encodeString(`allMessages-${id}-${key}`)}`);
};

export default {
  checkStorageAvailability,
  removeLocalStorage,
};
